import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import {
    $getRoot,
    $getSelection,
    $createTextNode,
    COMMAND_PRIORITY_HIGH,
    KEY_BACKSPACE_COMMAND
} from "lexical";
import { $createHeadingNode, $isHeadingNode } from "@lexical/rich-text";

export default function ForceHeadingPlugin() {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        return editor.registerUpdateListener(({ editorState }) => {
            editorState.read(() => {
                const root = $getRoot();
                const firstChild = root.getFirstChild();

                if (!firstChild || !$isHeadingNode(firstChild) || firstChild.getTag() !== "h1") {
                    editor.update(() => {
                        const newH1 = $createHeadingNode("h1");
                        newH1.append($createTextNode("Title"));
                        if (firstChild) {
                            firstChild.insertBefore(newH1);
                        } else {
                            root.append(newH1);
                        }
                    });
                }
            });
        });
    }, [editor]);

    useEffect(() => {
        const removePrevention = editor.registerCommand(
            KEY_BACKSPACE_COMMAND,
            () => {
                const selection = editor.getEditorState().read(() => $getSelection());
                const root = editor.getEditorState().read(() => $getRoot());
                const firstChild = root.getFirstChild();
                // Prevent deleting if selection is inside or at start of H1
                if (firstChild && $isHeadingNode(firstChild)) {
                    if (selection && selection.anchor.key === firstChild.getKey()) {
                        return true; // stop delete
                    }
                }
                return false;
            },
            COMMAND_PRIORITY_HIGH
        );

        return () => {
            removePrevention();
        };
    }, [editor]);

    return null;
}
